import { Box, IconButton, Stack, useTheme } from '@mui/material';

import CloseIcon from '../icons/CloseIcon';
import { CREATE_SERVICE_HEADER_HEIGHT } from 'constants/ui/style';

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  steps: React.ReactNode;
  title: React.ReactNode;
};

const CreateNewServiceContainer = (props: Props) => {
  const { children, onClose, steps, title } = props;
  const { palette } = useTheme();
  return (
    <Stack sx={{ height: '100vh', overflow: 'hidden' }}>
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          padding: '0 2rem',
          marginX: '-2rem', //default 2rem in MainLayout
          height: CREATE_SERVICE_HEADER_HEIGHT,
          flexShrink: 0,
          borderBottom: `1px solid ${palette.borderColor.main}`,
        }}
      >
        <>{title}</>

        <>{steps}</>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {/* Content */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default CreateNewServiceContainer;
